// Client Portal i18n — English-keyed Spanish dictionary.
// t('My Profile') returns the Spanish string when the portal language is
// 'es', otherwise the key itself. Unknown keys fall back to English, so a
// missing translation can never break the UI.

export const ES = {
  // Header / chrome
  'Client Portal': 'Portal del Cliente',
  'Welcome,': 'Bienvenido/a,',
  'Logout': 'Cerrar sesión',
  'Notifications': 'Notificaciones',
  'No notifications': 'Sin notificaciones',
  'Mark all as read': 'Marcar todo como leído',
  'Access Denied': 'Acceso denegado',
  'Portal section': 'Sección del portal',

  // Tabs / navigation
  'My Profile': 'Mi Perfil',
  'My Appointments': 'Mis Citas',
  'My Messages': 'Mis Mensajes',
  'My Documents': 'Mis Documentos',
  'Medical Records': 'Expediente Médico',
  'Assessments': 'Evaluaciones',
  'Releases': 'Autorizaciones',
  'Billing': 'Facturación',
  'pending': 'pendiente(s)',
  'due': 'adeudado',

  // Common actions
  'Save': 'Guardar',
  'Cancel': 'Cancelar',
  'Submit': 'Enviar',
  'Send': 'Enviar',
  'Close': 'Cerrar',
  'View': 'Ver',
  'Download': 'Descargar',
  'Sign': 'Firmar',
  'Reply': 'Responder',
  'Back': 'Atrás',
  'Next': 'Siguiente',
  'Edit': 'Editar',
  'Delete': 'Eliminar',
  'Select': 'Seleccionar',
  'Clear': 'Borrar',
  'Loading...': 'Cargando...',
  'Saving...': 'Guardando...',
  'Sending...': 'Enviando...',
  'Submitting...': 'Enviando...',
  'No Thanks': 'No, gracias',
  'Select all that apply': 'Seleccione todas las opciones que correspondan',

  // Profile tab
  'Basic Information': 'Información Básica',
  'Contact Information': 'Información de Contacto',
  'Demographics': 'Datos Demográficos',
  'Medical Information': 'Información Médica',
  'Insurance Information': 'Información del Seguro',
  'Emergency Contact': 'Contacto de Emergencia',
  'Guardian Information': 'Información del Tutor',
  'Referral Information': 'Información de Referencia',
  'Service Preferences': 'Preferencias de Servicio',
  'Your Information': 'Su Información',
  'Request Profile Changes': 'Solicitar Cambios de Perfil',
  'Profile Update': 'Actualización de Perfil',
  'Full Name': 'Nombre Completo',
  'Preferred Name': 'Nombre Preferido',
  'Date of Birth': 'Fecha de Nacimiento',
  'Gender': 'Género',
  'Marital Status': 'Estado Civil',
  'Race': 'Raza',
  'Ethnicity': 'Etnicidad',
  'Primary Language': 'Idioma Principal',
  'Interpreter Needed': 'Necesita Intérprete',
  'Occupation': 'Ocupación',
  'Email': 'Correo Electrónico',
  'Phone': 'Teléfono',
  'Address': 'Dirección',
  'Best Times to Call': 'Mejores Horarios para Llamar',
  'Client ID': 'ID del Cliente',
  'Name': 'Nombre',
  'Relationship': 'Parentesco',
  'Same Household': 'Mismo Hogar',
  'Contact Person': 'Persona de Contacto',
  'Guardian Name': 'Nombre del Tutor',
  'Guardian Email': 'Correo del Tutor',
  'Guardian Phone': 'Teléfono del Tutor',
  'Not provided': 'No proporcionado',
  'Not selected': 'No seleccionado',
  'No data': 'Sin datos',
  'Allergies': 'Alergias',
  'No known allergies': 'Sin alergias conocidas',
  'Medical Alerts': 'Alertas Médicas',
  'Medication': 'Medicamento',
  'Dosage': 'Dosis',
  'Frequency': 'Frecuencia',
  'Prescriber': 'Médico que receta',
  'No medications on file': 'No hay medicamentos registrados',
  'No diagnoses on file': 'No hay diagnósticos registrados',
  'No vitals recorded': 'No hay signos vitales registrados',
  'Last Physical': 'Último Examen Físico',
  'Primary Care Physician': 'Médico de Atención Primaria',
  'PCP Address': 'Dirección del Médico Primario',
  'PCP Phone': 'Teléfono del Médico Primario',
  'Weight': 'Peso',
  'Symptoms': 'Síntomas',
  'Primary Insurance': 'Seguro Principal',
  'Secondary Insurance': 'Seguro Secundario',
  'Tertiary Insurance': 'Seguro Terciario',
  'Insurance': 'Seguro',
  'Insurance Company': 'Compañía de Seguro',
  'Member ID': 'Número de Afiliado',
  'Group Number': 'Número de Grupo',
  'Relationship to Insured': 'Parentesco con el Asegurado',
  'Insured Name': 'Nombre del Asegurado',
  'Insured Date of Birth': 'Fecha de Nacimiento del Asegurado',
  'Eligibility Status': 'Estado de Elegibilidad',
  'Effective Date': 'Fecha de Vigencia',
  'Expiration': 'Vencimiento',
  'No insurance on file': 'No hay seguro registrado',
  'No insurance information on file': 'No hay información de seguro registrada',
  'Preferred Location': 'Ubicación Preferida',
  'Preferred Mode': 'Modalidad Preferida',
  'Preferred Provider Type': 'Tipo de Proveedor Preferido',
  'Referral Type': 'Tipo de Referencia',
  'Referral Source': 'Fuente de Referencia',
  'Referral Contact': 'Contacto de Referencia',
  'Reason for Referral': 'Motivo de la Referencia',
  'Pets in Home': 'Mascotas en el Hogar',
  'Safety': 'Seguridad',
  'General': 'General',
  'Credentials': 'Credenciales',
  'Provider Name': 'Nombre del Proveedor',

  // Appointments tab
  'Upcoming Appointments': 'Próximas Citas',
  'Past Appointments': 'Citas Anteriores',
  'Appointment': 'Cita',
  'No appointments scheduled': 'No hay citas programadas',
  'Your appointments will appear here once they are scheduled': 'Sus citas aparecerán aquí una vez que sean programadas',
  'View your scheduled and past appointments': 'Vea sus citas programadas y anteriores',
  'Request to Reschedule Appointment': 'Solicitar Reprogramación de Cita',
  'Propose a New Time': 'Proponer un Nuevo Horario',
  'Please contact me to discuss': 'Por favor contácteme para conversar',
  'Date': 'Fecha',
  'Status': 'Estado',

  // Messages tab
  'New Message': 'Nuevo Mensaje',
  'No messages yet': 'Aún no hay mensajes',
  'Start a conversation with your provider or office staff': 'Inicie una conversación con su proveedor o el personal de la oficina',
  'Type a message to enable send button': 'Escriba un mensaje para habilitar el botón de enviar',
  'Subject': 'Asunto',
  'Message': 'Mensaje',
  'To': 'Para',

  // Documents tab
  'Documents for Review & Signature': 'Documentos para Revisión y Firma',
  'Documents sent to you by your provider': 'Documentos enviados por su proveedor',
  'Documents requiring your attention will appear here': 'Los documentos que requieran su atención aparecerán aquí',
  'No pending documents': 'No hay documentos pendientes',
  'Document content is empty': 'El contenido del documento está vacío',
  'Document has no fields to display': 'El documento no tiene campos para mostrar',
  'Signature Required': 'Firma Requerida',
  'Your Signature Required': 'Se Requiere Su Firma',
  'Your Signature': 'Su Firma',
  'Draw Your Signature': 'Dibuje Su Firma',
  'Type Your Full Name': 'Escriba Su Nombre Completo',
  'Type your full legal name': 'Escriba su nombre legal completo',
  'Sign using your mouse or finger on touchscreen': 'Firme con el mouse o con el dedo en la pantalla táctil',
  'Signed': 'Firmado',
  'Client Declined': 'Rechazado por el Cliente',
  'Document Signed': 'Documento Firmado',

  // Medical records tab
  'My Medical Records Requests': 'Mis Solicitudes de Expediente Médico',
  'Track the status of your medical records requests': 'Siga el estado de sus solicitudes de expediente médico',
  'No medical records requests yet': 'Aún no hay solicitudes de expediente médico',
  'Request Release of Your Records': 'Solicitar la Divulgación de Su Expediente',
  'Personal Records Request': 'Solicitud Personal de Expediente',
  'Authorization for Release of Information': 'Autorización para la Divulgación de Información',
  'Please review and sign this release authorization': 'Por favor revise y firme esta autorización de divulgación',
  'Type of Release': 'Tipo de Divulgación',
  'Purpose of Disclosure': 'Propósito de la Divulgación',
  'Organization/Person Name': 'Nombre de la Organización/Persona',
  'My entire medical record': 'Mi expediente médico completo',
  'Choose specific date ranges and record types': 'Elija rangos de fechas y tipos de registros específicos',
  'Select all types of information to include in this release': 'Seleccione todos los tipos de información a incluir en esta divulgación',
  'This authorization is voluntary': 'Esta autorización es voluntaria',
  'I may revoke this authorization at any time in writing': 'Puedo revocar esta autorización en cualquier momento por escrito',
  'Respond to Information Request': 'Responder a la Solicitud de Información',
  'Service Requested': 'Servicio Solicitado',
  'No services selected': 'No se seleccionaron servicios',
  'Legal Proceedings': 'Procedimientos Legales',
  'Start Date': 'Fecha de Inicio',
  'End Date': 'Fecha de Fin',
  'Description': 'Descripción',

  // Assessments tab
  'No pending assessments': 'No hay evaluaciones pendientes',
  'Your provider will send you assessments when needed': 'Su proveedor le enviará evaluaciones cuando sea necesario',
  'Complete assessments requested by your provider': 'Complete las evaluaciones solicitadas por su proveedor',

  // Releases tab
  'No pending release authorizations': 'No hay autorizaciones de divulgación pendientes',
  'Any releases requiring your signature will appear here': 'Las autorizaciones que requieran su firma aparecerán aquí',

  // Billing tab
  'Make a Payment': 'Realizar un Pago',
  'Total Balance': 'Saldo Total',
  'Amount Due': 'Monto Adeudado',
  'Amount': 'Monto',
  'Credits/Prepayments': 'Créditos/Pagos Anticipados',
  'No billing information available': 'No hay información de facturación disponible',
  'Payment History': 'Historial de Pagos',
  'Method': 'Método',
  'Code': 'Código',
  'Plan': 'Plan',

  // Footer / misc
  'My Next Appointment': 'Mi Próxima Cita',
  'View All': 'Ver Todas',
  'Provider:': 'Proveedor:',
  'Service:': 'Servicio:',
  'Instructions from Provider:': 'Instrucciones del Proveedor:',
  'Your Care Team': 'Su Equipo de Atención',
  'Your Provider': 'Su Proveedor',
  'My Balance': 'Mi Saldo',
  'Your account is current!': '¡Su cuenta está al día!',
  'You have no outstanding balance.': 'No tiene saldo pendiente.',
  'Statements': 'Estados de Cuenta',
  'Pay Statement': 'Pagar Estado de Cuenta',
  'Outstanding Charges': 'Cargos Pendientes',
  'Terms of Use': 'Términos de Uso',
  'Privacy Policy': 'Política de Privacidad',
  'Technical details': 'Detalles técnicos',
  'Tags': 'Etiquetas',
  'Actions': 'Acciones',
  'Primary': 'Principal',
  'Clinical Context': 'Contexto Clínico',
  'Not likely': 'Poco probable',
  'Very likely': 'Muy probable',
  'Submit anonymously': 'Enviar de forma anónima',
  'Send Portal Link': 'Enviar Enlace del Portal',
  'Not captured at time of plan creation': 'No registrado al momento de crear el plan',
  // Medical records tab
  'Request Medical Records': 'Solicitar Expediente Médico',
  'Request copies of your medical records for personal use or to share with another provider': 'Solicite copias de su expediente médico para uso personal o para compartir con otro proveedor',
  'Available options:': 'Opciones disponibles:',
  'Portal Download (FREE - 14 days access)': 'Descarga por el Portal (GRATIS - acceso por 14 días)',
  'Fax ($5), Pickup ($10), or Mail ($15)': 'Fax ($5), Recoger ($10) o Correo ($15)',
  'Request Records': 'Solicitar Expediente',
  'Withdraw': 'Retirar',
  'Download Records': 'Descargar Expediente',
  'Pay Now': 'Pagar Ahora',
  'Payment link will be sent to your email': 'El enlace de pago se enviará a su correo electrónico',
  'Respond': 'Responder',
  'Review & Sign': 'Revisar y Firmar',
  'Submitted:': 'Enviado:',
  'Delivery:': 'Entrega:',
  'Records:': 'Expediente:',
  'From:': 'De:',
  'Denied:': 'Denegado:',
  'Questions:': 'Preguntas:',
  'Provider Instructions:': 'Instrucciones del Proveedor:',
  'Amount Due:': 'Monto Adeudado:',
  'Click "Request Records" above to submit your first request': 'Haga clic en "Solicitar Expediente" arriba para enviar su primera solicitud',
  'Loading requests...': 'Cargando solicitudes...',
  'Loading documents...': 'Cargando documentos...',
  'Loading releases...': 'Cargando autorizaciones...',
  'Access expired on': 'El acceso expiró el',
  'Access until': 'Acceso hasta el',
  'Access expires in': 'El acceso expira en',
  'days': 'días',
  'day': 'día',
  // Releases tab
  'Release of Information Authorizations': 'Autorizaciones de Divulgación de Información',
  'Review, sign, or request new authorizations for release of your health information': 'Revise, firme o solicite nuevas autorizaciones para la divulgación de su información de salud',
  'Request New Release': 'Solicitar Nueva Autorización',
  'Created:': 'Creado:',
  'Recipient:': 'Destinatario:',
  'Type:': 'Tipo:',
  'Previous': 'Anterior',
  'Update Request': 'Actualizar Solicitud',
  'Submit Request': 'Enviar Solicitud',
  'Request #': 'Solicitud #',
  'Request History (Past 90 Days)': 'Historial de Solicitudes (Últimos 90 Días)',
  'request': 'solicitud',
  'requests': 'solicitudes',
  'Portal Download (FREE)': 'Descarga por el Portal (GRATIS)',
  'Pickup ($10)': 'Recoger ($10)',
  'Mail ($15)': 'Correo ($15)',
  'How are we doing? Share your feedback': '¿Cómo lo estamos haciendo? Comparta su opinión',
  'SUBMITTED': 'ENVIADA',
  'APPROVED': 'APROBADA',
  'RECORDS READY': 'EXPEDIENTE LISTO',
  'COMPLETED': 'COMPLETADA',
  'DENIED': 'DENEGADA',
  'WITHDRAWN': 'RETIRADA',
  'PAYMENT REQUIRED': 'PAGO REQUERIDO',
  'PENDING CLIENT INFO': 'PENDIENTE DE INFORMACIÓN',
  'IN PROGRESS': 'EN PROCESO',
  // Medical records request dialog
  'Edit Medical Records Request': 'Editar Solicitud de Expediente Médico',
  'Step': 'Paso',
  'of': 'de',
  'Requester Information': 'Información del Solicitante',
  'I am requesting records for:': 'Solicito el expediente de:',
  'Myself': 'Mí mismo/a',
  'My Child (Parent/Guardian)': 'Mi Hijo/a (Padre/Madre/Tutor)',
  'Parent/Guardian Name': 'Nombre del Padre/Madre/Tutor',
  "Child's Name": 'Nombre del Niño/a',
  'Street Address *': 'Dirección *',
  'City *': 'Ciudad *',
  'State *': 'Estado *',
  'ZIP *': 'Código Postal *',
  'Phone Number *': 'Número de Teléfono *',
  'Email Address *': 'Correo Electrónico *',
  'What Records Do You Need?': '¿Qué Registros Necesita?',
  'Date Range:': 'Rango de Fechas:',
  'Record Types: *': 'Tipos de Registros: *',
  'Select a provider...': 'Seleccione un proveedor...',
  'Fax Number *': 'Número de Fax *',
  'Third Party Release (Optional)': 'Divulgación a Terceros (Opcional)',
  'Recipient Name': 'Nombre del Destinatario',
  'Recipient Phone': 'Teléfono del Destinatario',
  'Delivery Method': 'Método de Entrega',
  'Authorization & Signature': 'Autorización y Firma',
  'Primary Signature *': 'Firma Principal *',
  'Third Party Release Signature *': 'Firma de Divulgación a Terceros *',
};

let _lang = 'en';

export const setPortalLangGlobal = (lang) => {
  _lang = lang === 'es' ? 'es' : 'en';
};

export const getPortalLangGlobal = () => _lang;

export const t = (s) => (_lang === 'es' ? (ES[s] || s) : s);

// BCP-47 tag for date/time formatting in the portal's current language.
export const portalLocale = () => (_lang === 'es' ? 'es-US' : 'en-US');
